/* eslint-disable */
import PropTypes from 'prop-types';
import React from 'react';
import getOffset from 'dom-helpers/query/offset';
import getScrollTop from 'dom-helpers/query/scrollTop';
import getScrollLeft from 'dom-helpers/query/scrollLeft';
import dates from './utils/dates';

import EventCell from './EventCell';
import { isSelected } from './utils/selection';

const propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    position: PropTypes.object,
    popupOffset: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.shape({
            x: PropTypes.number,
            y: PropTypes.number,
        }),
    ]),
    events: PropTypes.array,
    selected: PropTypes.object,

    accessors: PropTypes.object.isRequired,
    components: PropTypes.object.isRequired,
    getters: PropTypes.object.isRequired,
    localizer: PropTypes.object.isRequired,
    onSelect: PropTypes.func,
    onDoubleClick: PropTypes.func,
    slotStart: PropTypes.instanceOf(Date),
    slotEnd: PropTypes.number,
};

class Popup extends React.Component {
    componentDidMount() {
        const { popupOffset = 5 } = this.props;
        // eslint-disable-next-line react/no-string-refs
        const { top, left, width, height } = getOffset(this.refs.root);
        const viewBottom = window.innerHeight + getScrollTop(window);
        const viewRight = window.innerWidth + getScrollLeft(window);
        const bottom = top + height;
        const right = left + width;

        if (bottom > viewBottom || right > viewRight) {
            let topOffset;
            let leftOffset;

            // eslint-disable-next-line max-len
            if (bottom > viewBottom)
                topOffset =
                    bottom - viewBottom + (popupOffset.y || +popupOffset || 0);
            // eslint-disable-next-line max-len
            if (right > viewRight)
                leftOffset =
                    right - viewRight + (popupOffset.x || +popupOffset || 0);

            this.setState({ topOffset, leftOffset }); //eslint-disable-line
        }
    }

    render() {
        const {
            events,
            selected,
            getters,
            accessors,
            components,
            onSelect,
            onDoubleClick,
            slotStart,
            slotEnd,
            localizer,
        } = this.props;

        const { left, width, top } = this.props.position;
        const topOffset = (this.state || {}).topOffset || 0;
        const leftOffset = (this.state || {}).leftOffset || 0;

        const style = {
            top: Math.max(0, top - topOffset),
            left: left - leftOffset,
            minWidth: width + width / 2,
        };

        return (
            // eslint-disable-next-line react/no-string-refs
            <div ref="root" style={style} className="rbc-overlay">
                <div className="rbc-overlay-header">
                    {localizer.format(slotStart, 'dayHeaderFormat')}
                </div>
                {events.map((event, idx) => (
                    <EventCell
                        // eslint-disable-next-line react/no-array-index-key
                        key={idx}
                        type="popup"
                        event={event}
                        getters={getters}
                        onSelect={onSelect}
                        accessors={accessors}
                        components={components}
                        onDoubleClick={onDoubleClick}
                        continuesPrior={dates.lt(
                            accessors.end(event),
                            slotStart,
                            'day',
                        )}
                        continuesAfter={dates.gte(
                            accessors.start(event),
                            slotEnd,
                            'day',
                        )}
                        selected={isSelected(event, selected)}
                    />
                ))}
            </div>
        );
    }
}

Popup.propTypes = propTypes;

export default Popup;
